import React from 'react';
import PropTypes from 'prop-types';

import SamplesSpecificationsTable from './SamplesSpecificationsTable';

const CategoricalComponent = props =>
  <div className="content-item" id="bottom-pane">
    <div className="flex space-between">
      <p className="font-700 mb-10">
        Summary Table
      </p>
    </div>

    <SamplesSpecificationsTable {...props.data} primaryParameter={props.primaryParameter} parameterLevel={props.primaryParameterLevel} />
  </div>;

CategoricalComponent.propTypes = {
  data: PropTypes.object.isRequired,

  primaryParameterLevel: PropTypes.string.isRequired,
  primaryParameter: PropTypes.string.isRequired
};

export default CategoricalComponent;
